import { configureStore } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { Provider, useDispatch } from 'react-redux'
import Aside from '../components/ListCompany/Aside'
import Main from '../components/ListCompany/Main'
import { CompanyContext } from '../contexts'
import { companyRequestReduce, loadCompanyRequests as loadCompanyRequestsAction } from '../slices/company_request_slice'
import { companyReducer, loadCompanies as loadCompaniesAction } from '../slices/company_slice'

const store = configureStore({
  reducer: {
    company: companyReducer,
    companyRequest: companyRequestReduce,
  },
})

function Company({ company_types }) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loadCompaniesAction())
    dispatch(loadCompanyRequestsAction())
  }, [])

  return (
    <>
      <CompanyContext.Provider value={{ company_types }}>
        <div className="company-main-container col-xs-12 col-md-10">
          <Main />
        </div>
        <div className="col-xs-12 col-md-2">
          <Aside />
        </div>
      </CompanyContext.Provider>
    </>
  )
}

export default function App({ company_types }) {
  return (
    <Provider store={store}>
      <Company company_types={company_types} />
    </Provider>
  )
}
